

































































































































import {
  defineComponent,
  computed,
  reactive,
  Ref,
  SetupContext,
} from '@vue/composition-api'
import moment from 'moment'

import { ReceiptState } from '@/types/store'
import { ISummaries, ISummary } from '@/types/receipt'
import useVuex from '@/utils/useVuex'

import { DatePicker } from '@/components/molecules'

type Props = {}

export default defineComponent({
  name: 'AdminBoard',
  components: {
    DatePicker,
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      isSummariesLoading: Ref<boolean>
      summaries: Ref<ISummaries>
      isDateOpen: boolean
      date: string
    }>({
      isSummariesLoading: useVuex<ReceiptState['isSummariesLoading']>(
        context,
        () => store.getters['receipt/isSummariesLoading'],
      ),
      summaries: useVuex<ReceiptState['summaries']>(
        context,
        () => store.getters['receipt/summaries'],
      ),
      isDateOpen: false,
      date: moment().format('YYYY-MM-DD'),
    })

    const rateCalcor = (target: number, total: number): string => {
      return total === 0
        ? '0.0 %'
        : `${(Math.round((target / total) * 10000) / 100).toFixed(2)} %`
    }
    const countRateCalcor = (
      summary: ISummary,
      total?: ISummary,
      unit = '枚',
    ) => {
      return {
        thisMonth: {
          count:
            summary.thisMonth < 0
              ? '-'
              : summary.thisMonth.toLocaleString() + ' ' + unit,
          rate:
            summary.thisMonth < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.thisMonth, total.thisMonth),
        },
        lastMonth: {
          count:
            summary.lastMonth < 0
              ? '-'
              : summary.lastMonth.toLocaleString() + ' ' + unit,
          rate:
            summary.lastMonth < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.lastMonth, total.lastMonth),
        },
        today: {
          count:
            summary.today < 0
              ? '-'
              : summary.today.toLocaleString() + ' ' + unit,
          rate:
            summary.today < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.today, total.today),
        },
        yesterday: {
          count:
            summary.yesterday < 0
              ? '-'
              : summary.yesterday.toLocaleString() + ' ' + unit,
          rate:
            summary.yesterday < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.yesterday, total.yesterday),
        },
        now: {
          count:
            summary.now < 0 ? '-' : summary.now.toLocaleString() + ' ' + unit,
          rate:
            summary.now < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.now, total.now),
        },
        thisMonthFirst: {
          count:
            summary.thisMonthFirst < 0
              ? '-'
              : summary.thisMonthFirst.toLocaleString() + ' ' + unit,
          rate:
            summary.thisMonthFirst < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.thisMonthFirst, total.thisMonthFirst),
        },
        lastMonthFirst: {
          count:
            summary.lastMonthFirst < 0
              ? '-'
              : summary.lastMonthFirst.toLocaleString() + ' ' + unit,
          rate:
            summary.lastMonthFirst < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.lastMonthFirst, total.lastMonthFirst),
        },
        todayFirst: {
          count:
            summary.todayFirst < 0
              ? '-'
              : summary.todayFirst.toLocaleString() + ' ' + unit,
          rate:
            summary.todayFirst < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.todayFirst, total.todayFirst),
        },
        yesterdayFirst: {
          count:
            summary.yesterdayFirst < 0
              ? '-'
              : summary.yesterdayFirst.toLocaleString() + ' ' + unit,
          rate:
            summary.yesterdayFirst < 0 || total === undefined
              ? '-'
              : rateCalcor(summary.yesterdayFirst, total.yesterdayFirst),
        },
      }
    }
    const summaries = computed(() => {
      return [
        {
          title: 'レシート投稿者数',
          colspan: 1,
          rowspan: 1,
          subtitle: 'UU数',
          thisMonth: {
            count: `${state.summaries.contributerUU.thisMonth} 人`,
            rate: '-',
          },
          lastMonth: {
            count: `${state.summaries.contributerUU.lastMonth} 人`,
            rate: '-',
          },
          today: {
            count: `${state.summaries.contributerUU.today} 人`,
            rate: '-',
          },
          yesterday: {
            count: `${state.summaries.contributerUU.yesterday} 人`,
            rate: '-',
          },
          now: {
            count: '-',
            rate: '-',
          },
          thisMonthFirst: {
            count: '-',
            rate: '-',
          },
          lastMonthFirst: {
            count: '-',
            rate: '-',
          },
          todayFirst: {
            count: '-',
            rate: '-',
          },
          yesterdayFirst: {
            count: '-',
            rate: '-',
          },
        },
        {
          title: '流入レシート数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.inComing,
            state.summaries.inComing,
          ),
        },
        {
          title: '重複レシート数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.duplicated,
            state.summaries.inComing,
          ),
        },
        {
          title: 'システム（OCR）',
          colspan: 1,
          rowspan: 8,
          subtitle: 'OK（非完全自動連携）',
          ...countRateCalcor(
            state.summaries.system.ok,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'OK（完全自動連携）',
          ...countRateCalcor(
            state.summaries.system.autoCompleted,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '電話番号判読NG',
          ...countRateCalcor(
            state.summaries.system.noPhone,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'チェーン名判読NG',
          ...countRateCalcor(
            state.summaries.system.noShop,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '対象レシート外NG',
          ...countRateCalcor(
            state.summaries.system.invalidChainStore,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '日付判読NG',
          ...countRateCalcor(
            state.summaries.system.noDateTime,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '日付有効期間外NG',
          ...countRateCalcor(
            state.summaries.system.invalidDateTime,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '対象カテゴリ商品なし',
          ...countRateCalcor(
            state.summaries.system.noTargetCategoryItem,
            state.summaries.inComing,
          ),
        },
        {
          title: 'リーダー（システムNG判定）',
          colspan: 1,
          rowspan: 4,
          subtitle: '未処理残',
          ...countRateCalcor(
            state.summaries.leaderForSystemNg.incompleted,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '店舗登録申請数',
          ...countRateCalcor(
            state.summaries.leaderForSystemNg.shopApplying,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'OK判定数',
          ...countRateCalcor(
            state.summaries.leaderForSystemNg.ok,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'NG判定数',
          ...countRateCalcor(
            state.summaries.leaderForSystemNg.ng,
            state.summaries.inComing,
          ),
        },
        {
          title: 'リンカー',
          colspan: 1,
          rowspan: 4,
          subtitle: '未処理残',
          ...countRateCalcor(
            state.summaries.linker.incompleted,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: '処理中',
          ...countRateCalcor(
            state.summaries.linker.wip,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'OK判定数',
          ...countRateCalcor(
            state.summaries.linker.ok,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'NG判定数',
          ...countRateCalcor(
            state.summaries.linker.ng,
            state.summaries.inComing,
          ),
        },
        {
          title: 'リーダー（リンカーNG判定）',
          colspan: 1,
          rowspan: 3,
          subtitle: 'リンカーNG未処理残',
          ...countRateCalcor(
            state.summaries.leaderForLinkerNg.incompleted,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'OK判定数',
          ...countRateCalcor(
            state.summaries.leaderForLinkerNg.ok,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 1,
          rowspan: 0,
          subtitle: 'NG判定数',
          ...countRateCalcor(
            state.summaries.leaderForLinkerNg.ng,
            state.summaries.inComing,
          ),
        },
        {
          title: 'データ化レシート数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.completed,
            state.summaries.inComing,
          ),
        },
        {
          title: '',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          thisMonth: { count: '', rate: '' },
          lastMonth: { count: '', rate: '' },
          today: { count: '', rate: '' },
          yesterday: { count: '', rate: '' },
          now: { count: '', rate: '' },
          thisMonthFirst: { count: '', rate: '' },
          lastMonthFirst: { count: '', rate: '' },
          todayFirst: { count: '', rate: '' },
          yesterdayFirst: { count: '', rate: '' },
        },
        {
          title: 'データ化商品数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.completedItem,
            state.summaries.completedItem,
            '個',
          ),
        },
        {
          title: '自動連携商品数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.autocompletedItem,
            state.summaries.completedItem,
            '個',
          ),
        },
        {
          title: '新規紐付商品数残数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.newItem,
            state.summaries.completedItem,
            '個',
          ),
        },
        {
          title: '紐付変更商品残数',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          ...countRateCalcor(
            state.summaries.reItem,
            state.summaries.completedItem,
            '個',
          ),
        },
        {
          title: '',
          colspan: 2,
          rowspan: 1,
          subtitle: '',
          thisMonth: { count: '', rate: '' },
          lastMonth: { count: '', rate: '' },
          today: { count: '', rate: '' },
          yesterday: { count: '', rate: '' },
          now: { count: '', rate: '' },
          thisMonthFirst: { count: '', rate: '' },
          lastMonthFirst: { count: '', rate: '' },
          todayFirst: { count: '', rate: '' },
          yesterdayFirst: { count: '', rate: '' },
        },
        {
          title: 'リンカー稼働数',
          colspan: 1,
          rowspan: 1,
          subtitle: 'UU数',
          thisMonth: {
            count: `${state.summaries.linkerUU.thisMonth} 人`,
            rate: '-',
          },
          lastMonth: {
            count: `${state.summaries.linkerUU.lastMonth} 人`,
            rate: '-',
          },
          today: { count: `${state.summaries.linkerUU.today} 人`, rate: '-' },
          yesterday: {
            count: `${state.summaries.linkerUU.yesterday} 人`,
            rate: '-',
          },
          now: {
            count: '-',
            rate: '-',
          },
          thisMonthFirst: {
            count: '-',
            rate: '-',
          },
          lastMonthFirst: {
            count: '-',
            rate: '-',
          },
          todayFirst: {
            count: '-',
            rate: '-',
          },
          yesterdayFirst: {
            count: '-',
            rate: '-',
          },
        },
        {
          title: 'リーダー稼働数',
          colspan: 1,
          rowspan: 1,
          subtitle: 'UU数',
          thisMonth: {
            count: `${state.summaries.leaderUU.thisMonth} 人`,
            rate: '-',
          },
          lastMonth: {
            count: `${state.summaries.leaderUU.lastMonth} 人`,
            rate: '-',
          },
          today: { count: `${state.summaries.leaderUU.today} 人`, rate: '-' },
          yesterday: {
            count: `${state.summaries.leaderUU.yesterday} 人`,
            rate: '-',
          },
          now: {
            count: '-',
            rate: '-',
          },
          thisMonthFirst: {
            count: '-',
            rate: '-',
          },
          lastMonthFirst: {
            count: '-',
            rate: '-',
          },
          todayFirst: {
            count: '-',
            rate: '-',
          },
          yesterdayFirst: {
            count: '-',
            rate: '-',
          },
        },
      ]
    })

    const shouldDisplay = computed<boolean>(() => {
      return (
        state.summaries.inComing.lastMonth +
          state.summaries.inComing.thisMonth +
          state.summaries.inComing.yesterday +
          state.summaries.inComing.today >
        0
      )
    })

    const onClickFilter = () => {
      // store.dispatch('receipt/getSummaries', moment(state.date).valueOf())
    }

    return {
      state,
      summaries,
      shouldDisplay,
      onClickFilter,
    }
  },
})
